import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import NotificationsPopover from "../components/NotificationsPopover";
import BrandLogo from "../components/BrandLogo";
import { FiHome } from "react-icons/fi";
import chatService from "../services/chatService";
import { startChatPresenceHeartbeat } from "../utils/chatPresence";

// ─── Nav items ────────────────────────────────────────────────────────────────
// const NAV_ITEMS = [
//     {
//         to: '/home',
//         label: 'Home',
//         icon: (
//             <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16">
//                 <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
//                 <polyline points="9 22 9 12 15 12 15 22" />
//             </svg>
//         ),
//     },
//     {
//         to: '/projects',
//         label: 'Projects',
//         icon: (
//             <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16">
//                 <rect x="3" y="3" width="7" height="7" rx="1" />
//                 <rect x="14" y="3" width="7" height="7" rx="1" />
//                 <rect x="14" y="14" width="7" height="7" rx="1" />
//                 <rect x="3" y="14" width="7" height="7" rx="1" />
//             </svg>
//         ),
//     },
//     {
//         to: '/packages',
//         label: 'Packages',
//         icon: (
//             <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16">
//                 <path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z" />
//                 <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
//                 <line x1="12" y1="22.08" x2="12" y2="12" />
//             </svg>
//         ),
//     },
//     {
//         to: '/finance',
//         label: 'Finance',
//         icon: (
//             <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16">
//                 <line x1="12" y1="1" x2="12" y2="23" />
//                 <path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6" />
//             </svg>
//         ),
//     },
//     {
//         to: '/dashboard',
//         label: 'Dashboard',
//         icon: (
//             <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16">
//                 <rect x="3" y="3" width="7" height="9" rx="1" />
//                 <rect x="14" y="3" width="7" height="5" rx="1" />
//                 <rect x="14" y="12" width="7" height="9" rx="1" />
//                 <rect x="3" y="16" width="7" height="5" rx="1" />
//             </svg>
//         ),
//     },
//     {
//         to: '/requirements',
//         label: 'Requirements',
//         icon: (
//             <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16">
//                 <path d="M9 11l3 3L22 4" />
//                 <path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11" />
//             </svg>
//         ),
//     },
// ]

const NAV_ITEMS = [
  {
    to: "/packages",
    label: "Home",
    icon: (
      <FiHome size={16} aria-hidden="true" />
    ),
  },
];
export default function ClientLayout() {
  const navigate = useNavigate();
  const { logout, user, userLoading } = useAuth();
  const [chatOpen, setChatOpen] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const [unreadMessages, setUnreadMessages] = useState(0);

  useEffect(() => {
    if (!user) {
      return undefined;
    }
    const stopHeartbeat = startChatPresenceHeartbeat();
    const refreshUnread = () => {
      chatService
        .getUnreadCount()
        .then(setUnreadMessages)
        .catch(() => undefined);
    };

    refreshUnread();
    const timer = window.setInterval(refreshUnread, 30_000);
    return () => {
      stopHeartbeat();
      window.clearInterval(timer);
    };
  }, [user]);
  const [mobileMenu, setMobileMenu] = useState(false);

  const closeAll = () => {
    setChatOpen(false);
    setProfileOpen(false);
  };

  // Get user initials
  const getUserInitials = () => {
    if (!user) return "U";
    const firstInitial = user.firstName?.charAt(0) || "";
    const lastInitial = user.lastName?.charAt(0) || "";
    return (firstInitial + lastInitial).toUpperCase() || "U";
  };

  // Get full name
  const getFullName = () => {
    if (!user) return "User";
    return `${user.firstName || ""} ${user.lastName || ""}`.trim() || "User";
  };

  return (
    <div className="cl-shell">
      {/* ══════════════════ HEADER ══════════════════ */}
      <header className="cl-header">
        {/* Logo */}
        <button
          type="button"
          className="cl-logo"
          onClick={() => navigate("/packages")}
        >
          <BrandLogo />
        </button>

        {/* Desktop Nav */}
        <nav className="cl-nav">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `cl-nav-link ${isActive ? "cl-nav-active" : ""}`
              }
            >
              {item.icon}
              {item.label}
            </NavLink>
          ))}
        </nav>

        {/* Right controls */}
        <div className="cl-header-right">
          <NavLink to="/messages" className="cl-icon-btn cl-messages-link" title="Messages">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="17" height="17">
              <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" />
            </svg>
            {unreadMessages > 0 && <span className="cl-chat-dot" />}
          </NavLink>

          <NotificationsPopover />

          {/* Avatar / profile dropdown */}
          <div className="cl-dropdown-wrap">
            <button
              id="cl-profile-btn"
              type="button"
              className="cl-avatar-btn"
              onClick={() => {
                setProfileOpen((p) => !p);
              }}
              title="Account"
            >
              <div className="cl-avatar-circle">{getUserInitials()}</div>
            </button>
            {profileOpen && (
              <div className="cl-dropdown cl-profile-dropdown">
                <div className="cl-profile-top">
                  <div className="cl-avatar-circle cl-avatar-lg">
                    {getUserInitials()}
                  </div>
                  <div>
                    <div className="cl-profile-name">
                      {userLoading ? "Loading..." : getFullName()}
                    </div>
                    <div className="cl-profile-email">
                      {user?.email || "user@example.com"}
                    </div>
                  </div>
                </div>
                <div className="cl-dropdown-divider" />
                {[
                  { label: "My Orders", to: "/my-orders" },
                  { label: "Finance", to: "/finance?tab=dashboard" },
                  { label: "My Profile", to: "/profile" },
                ].map((item) => (
                  <button
                    key={item.to}
                    type="button"
                    className="cl-dropdown-item"
                    onClick={() => {
                      navigate(item.to);
                      setProfileOpen(false);
                    }}
                  >
                    {item.label}
                  </button>
                ))}
                <div className="cl-dropdown-divider" />
                <button
                  type="button"
                  className="cl-dropdown-item cl-signout"
                  onClick={() => {
                    // Logout and clear auth state
                    logout();
                    // Navigate to login
                    navigate("/login");
                  }}
                >
                  Sign out
                </button>
              </div>
            )}
          </div>

          {/* Mobile hamburger */}
          <button
            type="button"
            className="cl-hamburger"
            onClick={() => setMobileMenu((p) => !p)}
            aria-label="Toggle menu"
          >
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              width="20"
              height="20"
            >
              {mobileMenu ? (
                <>
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </>
              ) : (
                <>
                  <line x1="3" y1="6" x2="21" y2="6" />
                  <line x1="3" y1="12" x2="21" y2="12" />
                  <line x1="3" y1="18" x2="21" y2="18" />
                </>
              )}
            </svg>
          </button>
        </div>
      </header>

      {/* Mobile nav overlay */}
      {mobileMenu && (
        <nav className="cl-mobile-nav">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `cl-mobile-link ${isActive ? "cl-nav-active" : ""}`
              }
              onClick={() => setMobileMenu(false)}
            >
              {item.icon}
              {item.label}
            </NavLink>
          ))}
        </nav>
      )}

      {/* Click-outside overlay to close dropdowns */}
      {(profileOpen || chatOpen) && (
        <div className="cl-overlay" onClick={closeAll} />
      )}

      {/* ══════════════════ PAGE CONTENT ══════════════════ */}
      <main className="cl-main">
        <Outlet />
      </main>
    </div>
  );
}
